export const DUMMY_ICONS = {
  infoToolTip:
    'https://assets1.cleartax-cdn.com/cleartax/images/1640160273_infotooltip.svg',
  closeButton:
    'https://assets1.cleartax-cdn.com/cleartax/images/1640183091_shape.svg',
};
